import { VARIANT_TABLE_SET_ACCESSORIES_PANEL_OPEN, VARIANT_TABLE_SET_STATE, } from '../constants';

export const setVariantTableQueryParam = (newState) => {
    return {
        type: VARIANT_TABLE_SET_ACCESSORIES_PANEL_OPEN,
        payload: newState
    }
};

export const setVariantTableState = (newState) => {
    return {
        type: VARIANT_TABLE_SET_STATE,
        payload: newState
    }
};
